import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import { DividendPayoutStatus } from '../../../hooks/dividend/dividend.types';
import { getTranslation } from '../../../utils/get-translation.util';

// An approved or paid out payout has already been reflected elsewhere, so its warning spells out
// what else gets removed (design 4946:32117).
const SETTLED_STATUS_LABEL: Partial<Record<DividendPayoutStatus, string>> = {
  [DividendPayoutStatus.APPROVED]: getTranslation('DIVIDEND_STATUS_APPROVED_PARTICIPLE'),
  [DividendPayoutStatus.PAID_OUT]: getTranslation('DIVIDEND_STATUS_PAID_OUT_PARTICIPLE'),
};

type Props = {
  isPending?: boolean;
  name: string;
  onClose: () => void;
  onSuccess: () => void;
  status: DividendPayoutStatus;
};

export const DividendDeleteModal: FC<Props> = ({ isPending, name, onClose, onSuccess, status }) => {
  const settledStatus = SETTLED_STATUS_LABEL[status];

  return (
    <div className="m-2 flex w-full min-w-[300px] flex-col gap-8 rounded bg-white p-4 xlg:w-[453px]">
      <div className="flex flex-col gap-4">
        <span className="text-xl font-[550] text-gray-700">
          <AppFormattedMessage id="DELETE_DIVIDEND_PAYOUT_TITLE" />
        </span>
        <span className="text-xs font-[450] text-gray-500">
          {settledStatus ? (
            <AppFormattedMessage
              id="DELETE_DIVIDEND_PAYOUT_SETTLED_DESCRIPTION"
              values={{ name, status: settledStatus }}
            />
          ) : (
            <AppFormattedMessage id="DELETE_DIVIDEND_PAYOUT_DESCRIPTION" values={{ name }} />
          )}
        </span>
      </div>
      <div className="flex h-11 justify-end gap-4">
        <Button
          className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
          onClick={onClose}
          styleType="NONE"
        >
          <AppFormattedMessage id="NO_KEEP" />
        </Button>
        <Button
          className="h-full w-fit bg-fireside-600 px-6 py-[10px] text-sm font-[550] text-white"
          isLoading={isPending}
          onClick={onSuccess}
          styleType="NONE"
        >
          <AppFormattedMessage id="YES_DELETE" />
        </Button>
      </div>
    </div>
  );
};
